import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { BaseButton, btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { USER_LOGIN_ROUTE } from '@r1-frontend/shared/constants/routes';

import { ConfirmCitySelection } from '~/src/features/_layout/Header/commonComponents/ConfirmCitySelection';
import CommonDesktopHeader from '~/src/features/_layout/Header/desktop/components/CommonDesktopHeader';
import {
    imagesParams,
} from '~/src/features/_layout/Header/desktop/components/UnauthDesktopHeader/connectionButtonAnimation';
import { IUnauthHeaderProps } from '~/src/features/_layout/Header/types';
import { useLeadGeneration } from '~/src/features/_layout/Header/UnauthHeader/useLeadGeneration';
import { useIsMsk } from '~/src/helpers/hooks/useIsMsk';
import { selectCompanyName } from '~/src/store/selectors/city';

import * as ST from '../CommonDesktopHeader/styled';

const UnauthDesktopHeader = ({
    onBecomeClientHandler,
    referrerPath,
    ...props
}: IUnauthHeaderProps): JSX.Element => {
    const [isHover, setIsHover] = useState(false);
    const companyName = useSelector(selectCompanyName);
    const { showButton } = useLeadGeneration();
    const isMsk = useIsMsk();

    const openConnectionPopup = () => {
        onBecomeClientHandler(isMsk ? 'callback' : 'connect');
    };

    const clientActions = useMemo(() => {
        return <ST.ClientActionsBlock>
            <BaseButton
                href={`${USER_LOGIN_ROUTE}${referrerPath}`}
                size={btnSizes.SMALL}
                type={btnTypes.SECONDARY}
                text={'Войти'}
                data-test='auth-link'
            />
            {showButton && (
                <>
                    <ST.SBaseButton
                        size={btnSizes.SMALL}
                        type={btnTypes.ACCENT}
                        text={'Подключить ' + companyName}
                        onClick={openConnectionPopup}
                        data-test='become-client-btn'
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    />

                    {imagesParams.map((item, index) => (
                        <ST.AnimationImg
                            key={`connection-button-animation-${index}`}
                            rotateOnLeave={item.rotateOnLeave}
                            top={item?.top}
                            right={item?.right}
                            left={item?.left}
                            isHover={isHover}
                        >
                            {item.text}
                        </ST.AnimationImg>
                    ))}
                </>
            )}
        </ST.ClientActionsBlock>;
    }, [companyName, isHover, onBecomeClientHandler, referrerPath, showButton]);

    return (
        <CommonDesktopHeader
            {...props}
            ClientActions={clientActions}
        >
            <ConfirmCitySelection/>
        </CommonDesktopHeader>
    );
};

export default UnauthDesktopHeader;
